import { ElementDimensions } from './Models/ElementDimensions';

/**
 * This file contains the ElementExtensions class which provides various utility methods for manipulating HTML elements.
 */

export class ElementExtensions {
    /**
     * Retrieves the dimensions of an HTML element.
     * @param element The HTML element.
     * @returns An object containing the dimensions of the element.
     */
    public GetElementDimensions(element: HTMLElement): ElementDimensions {
        const rect = element.getBoundingClientRect();
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        return new ElementDimensions(element.clientWidth, element.clientHeight, rect.top + scrollTop, rect.left + scrollLeft);
    }

    /**
     * Focuses on the parent element that matches the specified selector.
     * @param element The HTML element.
     * @param parentSelector The selector for the parent element.
     */
    public FocusParent(element: HTMLElement, parentSelector: string): void {
        var parent = element;
        var parentMatched = false;

        do {
            parent = parent.parentElement;
            parentMatched = parent === null || parent.matches(parentSelector) == true;
        }
        while (parentMatched == false);

        if (parent !== null) {
            parent.focus();
        }
        else {
            const activeElement = document.activeElement as HTMLElement;
            activeElement.blur();
        }
    }

    /**
     * Focuses on the element.
     * @param element The HTML element.
     */
    public Focus(element: HTMLElement): void {
        if (element === null || element === undefined || element.focus === undefined || document.activeElement === element) {
            return;
        }

        element.focus();
    }

    /**
     * Scrolls the element with the specified ID into view.
     * @param id The ID of the element to scroll into view.
     */
    public ScrollElementIntoView(id: string): void {
        const container = document.getElementById('date-selector-container');
        const element = document.getElementById(id);
        const parent = element.parentElement;
        const width = parent.clientWidth;
        const offset = parent.offsetLeft;
        const position = offset - (width / 2);

        container.scrollTo(position + 1, 0);
    }
}

window['ElementExtensions'] = new ElementExtensions();